module.exports = __webpack_public_path__ + "img/16.f8460186.jpg";